import React from 'react'

export default function Reviews() {
    return (
        <>
            {/* <section id="reviews">
                <br />
                <h5 style={{ "textAlign": "center", "marginTop": "2rem", "marginBottom": "1rem", "color": "orange" }}>EXPLORE THE  
                AWESOME</h5>
                <h1 style={{ "textAlign": "center", "fontSize": "3rem" }}>What Client Says</h1>
                <div className="review">
                    <div className="rev1">
                        <h1>People Say <br />
                            About Shri Shyam Interior</h1>
                        <p>One-stop solution for decorating your home. Poeple love Shri shyam decor because they can built their dream home with ease and at afforable price</p>
                        
                    </div>
                    <div className="rev">
                        <h3>Great quality</h3>
                        <p>
                            I wanted to place a review since their support helped me within a day or so, which is nice! Thanks
                            and 5 stars! </p>
                        <div className="img">
                            <img src="https://edumall.thememove.com/dark/wp-content/uploads/sites/5/2020/08/testimonial-avatar-01.jpg"
                                alt="" width="100px" />
                            <div>Oliver Beddows
                                <br /> /Designer, <br /> Manchester
                            </div>
                        </div>
                    </div>
                    <div className="rev">
                        <h3>Good Staff</h3>
                        <p>
                            SSD deserves 5 star for theme's features, design quality, flexibility, and support service!
                        </p>
                        <div className="img">
                            <img src="https://edumall.thememove.com/dark/wp-content/uploads/sites/5/2020/08/testimonial-avatar-02.jpg"
                                alt="" width="100px" />
                            <div>Madley Ponder
                                <br /> /eporter,diego
                            </div>
                        </div>
                    </div>
                    <div className="rev">
                        <h3>After support</h3>
                        <p>
                            Very good and fast support during the week. They know what you need, fixed the problem within few hours. </p>
                        <div className="img">
                            <img src="https://edumall.thememove.com/dark/wp-content/uploads/sites/5/2020/08/testimonial-avatar-03.jpg"
                                alt="" width="100px" />
                            <div>Mina Hollace
                                <br /> /eporter,London
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            <h5 style={{ "textAlign": "center", "marginTop": "2rem", "marginBottom": "1rem", "color": "orange" }}>EXPLORE THE  
                AWESOME</h5>
                <h1 style={{ "textAlign": "center", "fontSize": "3rem" }}>What Client Says</h1>

            <div id="carouselExampleIndicators" className="carousel slide " data-aos="fade-right" data-aos-delay="200" data-aos-duration="900" style={{'background':'url(https://cdn.shopify.com/s/files/1/1288/2227/files/testi_bg.jpg?v=1642397557)',"width":"100%","height":"40rem"}}>
                <div className="carousel-indicators"> 
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                </div>
                <div className="carousel-inner carousin" >
                    <div className="carousel-item active" >
                        <img src="https://vinay-gupt.github.io/Shri-Shyam-Decor/images/rev1.png" className="d-block carous"  alt="..." />
                        
                    </div>
                    <div className="carousel-item">
                        <img src="https://vinay-gupt.github.io/Shri-Shyam-Decor/images/rev2.png" className="d-block  carous"  alt="..." />
                    </div>
                    <div className="carousel-item">
                        <img src="https://vinay-gupt.github.io/Shri-Shyam-Decor/images/rev3.png" className="d-block  carous"  alt="..." />
                    </div>
                </div>
                <button className="carousel-control-prev" type="button" style={{"backgroundColor":"rgb(63 61 61)","width":"5%"}} data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" style={{"backgroundColor":"rgb(63 61 61)","width":"5%"}} type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
            
        </>
    )
}
